import { render } from "./UnregisterReception.vue?vue&type=template&id=71605402"
import script from "./UnregisterReception.vue?vue&type=script&lang=js"
export * from "./UnregisterReception.vue?vue&type=script&lang=js"

import "./UnregisterReception.vue?vue&type=style&index=0&id=71605402&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__